import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from "react";
import { setUserInfo, setIsAuthenticated } from "./store";

import Login from "./cmp/Login/login";
import Signup from "./cmp/Signup/signup";
import ForgotPasswordPage from './cmp/ForgotPassword/ForgotPasswordPage';
import LayoutPage from "./cmp/Layout/layout";
import DashboardContent from "./cmp/Layout/DashboardContent/dashboardContent";
import Orders from "./cmp/Layout/DashboardContent/Orders/Orders";
import RunAnalysis from "./cmp/Layout/DashboardContent/RunAnalysis/RunAnalysis";
import HistoryAnalysis from "./cmp/Layout/DashboardContent/HistoryAnalysis/HistoryAnalysis";
import HistoryAnalysisWithoutId from "./cmp/Layout/DashboardContent/HistoryAnalysis/HistoryAnalysisWithoutId";
import GuestAnalysis from "./cmp/GuestAnalysis/GuestAnalysis";
import ProtectedRoute from "./cmp/ProtectedRoute/ProtectedRoute";
import ChangePassword from "./cmp/Layout/Sidebar/ChangePassword/ChangePassword";
import DeleteAccount from "./cmp/Layout/Sidebar/deleteAccount/deleteAccount";
import ProfilePage from "./cmp/Layout/DashboardContent/Profile/profile";
import LoginLogs from "./cmp/Layout/DashboardContent/Orders/loginLogs/loginLogs";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Rfm from "./cmp/Layout/DashboardContent/HistoryAnalysis/tabs/rfm";
import ProductPage from "./cmp/Layout/DashboardContent/HistoryAnalysis/productPage/productpage";
import FavoritePage from "./cmp/Layout/favorite/favorite";
import ProductPageNew from "./cmp/Layout/DashboardContent/HistoryAnalysis/productPage/productpageNew";
import ProductAssignmentTool from "./cmp/test";
import ProductAssignmentDashboard from "./cmp/test";
import SettingsPage from "./cmp/Layout/DashboardContent/Profile/setting";

function App() {
  const dispatch = useDispatch();
  const [authChecked, setAuthChecked] = useState(false);


  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = localStorage.getItem("userInfo");
    if (token && user) {
      dispatch(setUserInfo(JSON.parse(user)));
      dispatch(setIsAuthenticated(true));
    }
    setAuthChecked(true);
  }, [dispatch]);

  if (!authChecked) {
    return <div>Loading...</div>; // or a spinner
  }

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000} // default 3 seconds
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
      />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        {/* <Route path="/signup" element={<Signup />} /> */}
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/guest-analysis" element={<GuestAnalysis />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<LayoutPage />}>
            <Route index element={<DashboardContent />} />
            <Route path="dashboard" element={<DashboardContent />} />
            <Route path="orders/:id" element={<Orders />} />
            <Route path="run-analysis" element={<RunAnalysis />} />
            {/* <Route path="history-analysis/:id" element={<HistoryAnalysis />} /> */}
            <Route path="history-analysis" element={<HistoryAnalysis />} />
            {/* <Route path="change-password" element={<ChangePassword />} />
            <Route path="delete-account" element={<DeleteAccount />} /> */}
            <Route path="profile-account" element={<ProfilePage />} />
            <Route path="setting" element={<SettingsPage />} />
            <Route path="login-logs" element={<LoginLogs />} />
            <Route path="rfm" element={<Rfm />} />
            <Route path="k-means" element={<Rfm />} />
            <Route path="product" element={<ProductPageNew />} />
            <Route path="favorite" element={<FavoritePage />} />
            <Route path="test" element={<ProductAssignmentDashboard />} />

          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
